// Authentication component for the login page. This component will handle the login
// form and authentication logic.
// It will receive the username and password from the user,
// send it to the server for authentication
// and update the context with the user information and authentication status.

import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppContext } from '../store/context/context';
import { confirmUserExists, authenticateUser } from '../helpers/databaseFiles';
import styles from '../css/login.module.css';
import { serverURL } from '../helpers/dataServerURL';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaSignInAlt } from 'react-icons/fa';

export default function Login() {
  const loginURL = serverURL.server.url;
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const contextCTX = useContext(AppContext);
  const navigate = useNavigate();
  const getFocusRef = useRef(null);

  useEffect(() => {
    if (getFocusRef.current) {
      getFocusRef.current.focus();
    }
  }, []);

  //   Verify that the user exists in the database by calling the confirmUserExists function.
  async function verifyUser() {
    try {
      const userExists = await confirmUserExists(loginURL, user);
      if (!userExists) {
        setErrorMessage('User does not exist.');
        return;
      } else {
        console.log('User exists, proceeding to authenticate.', user, password);
      }

      const authUser = await authenticateUser(loginURL, user, password);
      if (authUser.pass) {
        setIsAuthenticated(true);
        contextCTX.setUser(authUser.username);
        contextCTX.setIsAuth();
        contextCTX.isAuth = isAuthenticated; // Ensure isAuth is set to true
        localStorage.setItem('isAuth', 'true');
        navigate('/');
      } else {
        setErrorMessage('Invalid username or password.');
      }
    } catch (error) {
      setErrorMessage(`Error verifying user. ${error.message}`);
    }
  }

  return (
    <div>
      <div className={styles.loginContainer}>
        <form className={styles.loginForm} action={verifyUser} autoComplete="off">
          <h2 className={styles.loginTitle}>
            <FaSignInAlt color="black" style={{ paddingTop: '7px' }} /> Login Form
          </h2>
          <div>
            <FaUser color="lightgray" className={styles.userIcon} />
            <input
              ref={getFocusRef}
              type="text"
              placeholder="UserName"
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />
          </div>
          <div>
            <FaLock color="lightgray" className={styles.lockIcon} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className={styles.loginButton}>
            Login
          </button>
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
}
